import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { WiseBoardSidebar } from "./WiseBoardSidebar";
import { Outlet } from "react-router-dom";
import wiseBoardLogo from "@/assets/wiseboard-logo.png";

export function WiseBoardLayout() {
  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full bg-background">
        <WiseBoardSidebar />
        <div className="flex-1 flex flex-col min-w-0">
          <header className="h-14 flex items-center border-b px-4 gap-3 bg-card shrink-0">
            <SidebarTrigger />
            <img src={wiseBoardLogo} alt="WiseBoard" className="h-[4.5rem] w-auto" />
          </header>
          <main className="flex-1 overflow-auto">
            <Outlet />
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}
